import * as React from "react";
const SvgFiRrUmbrella = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-umbrella_svg__a)">
      <path
        fill="#062147"
        d="M23.718 9.549A12.83 12.83 0 0 0 13 2.043V1a1 1 0 0 0-2 0v1.043A12.84 12.84 0 0 0 .267 9.549a3.95 3.95 0 0 0 .405 3.682A4.02 4.02 0 0 0 4 15h7v6a1 1 0 0 1-2 0 1 1 0 1 0-2 0 3 3 0 0 0 6 0v-6h6.983a4.017 4.017 0 0 0 3.99-3.56 3.95 3.95 0 0 0-.255-1.891m-2.061 2.561a2 2 0 0 1-1.674.89H4a1.99 1.99 0 0 1-1.673-.891 1.93 1.93 0 0 1-.2-1.818C3.581 6.646 7.734 4 12.001 4a10.81 10.81 0 0 1 9.859 6.291 1.92 1.92 0 0 1-.203 1.819"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-umbrella_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUmbrella;
